import { EditableCard } from "../../../components/editableCard.component";
import { ProfileCardPlaceholder } from "../../../components/placeholders.component";
import { ApiSchemaCaregiver } from "../../../models/api";
import { AppRouteUi, AppRouteApi } from "../../../config/appRoute";
import { useParams } from "react-router";
import { Image } from "../../../components/image.component";

type Props = {
  data: ApiSchemaCaregiver | undefined;
  isValidating: boolean;
};

export const ProfileCard = (props: Props) => {
  const { caregiverId } = useParams<{ caregiverId: string }>();

  return (
    <EditableCard
      title="Caregiver Profile"
      isValidating={props.isValidating}
      link={`${AppRouteUi.Caregiver.Root()}/update/${caregiverId}`}
      className="mb-3"
      showEditButton
      showBackButton
    >
      {props.isValidating ? (
        <ProfileCardPlaceholder />
      ) : (
        <div className="d-flex align-items-center">
          <div>
            <Image
              src={
                props.data?.profilePic
                  ? AppRouteApi.Media.ByPath(props.data.profilePic)
                  : "/img/admin-profile.svg"
              }
              alt="Profile"
              className="p-5 rounded-circle object-fit-cover"
              width={150}
              height={150}
            />
          </div>
          <div className="ms-1 me-5">
            <h4 className="display-6">
              {props.data?.firstName} {props.data?.lastName}
            </h4>
          </div>
        </div>
      )}
    </EditableCard>
  );
};
